/**
 * Size Rec Items Queries
 */
import gql from 'graphql-tag'

export const getStoreItemsSizeRecQuery = gql`
  query getStoreItemsSizeRec($storeId: Int, $fromLocker: Boolean, $searchTerm: String, $limit: Int, $offset: Int) {
    items: getStoreItemsSizeRec(
      storeId: $storeId, fromLocker: $fromLocker, searchTerm: $searchTerm, limit: $limit, offset: $offset
    ) {
      fullCount
      designs {
        id
        code
        name
        image
        productId: product_id
        productName: product_name
        description: short_description
        fitPreferences: fit_preferences
        images: pictures2 {
          front: front_image
          thumbnail
        }
      }
    }
  }
`

export const getUserSizeRecItemsQuery = gql`
  query getUserSizeRecItems($userId: Int!) {
    items: getUserSizeRecItems(userId: $userId) {
      product_id
      profileOwner: profile_owner
    }
  }
`

export const deleteSizeRecMutation = gql`
  mutation deleteSizeRec($id: Int!) {
    deleteSizeRec(id: $id) {
      message
    }
  }
`

export const getFitProfileQuery = gql`
  query getUserFitProfiles {
    fitProfiles: getUserFitProfiles {
      id
      role
      profileOwner: profile_owner
      firstName: first_name
      lastName: last_name
      unit
      gender
      height
      weight
      completedAt: completed_at
      chest
      outseam
      waist
      low_hips
      neck
      inside_leg_height
      upper_arm_length
    }
  }
`

export const sendSizeRecRequestMutation = gql`
  mutation sendSizeRecRequest($input: SizeRecInput!, $deviceInfo: DeviceInfo) {
    sendSizeRecRequest(input: $input, deviceInfo: $deviceInfo) {
      message
      status: shortId
      id
    }
  }
`

export const updateSizeRecMutation = gql`
  mutation updateSizeRecRequest($id: Int!, $manualFit: ManualProfile!) {
    updateSizeRecRequest(id: $id, manualFit: $manualFit) {
      message
    }
  }
`

export const sendSizeRecReminderMutation = gql`
  mutation sendSizeRecReminder($userName: String!, $customerEmail: String!, $role: String, $profile: String) {
    sendSizeRecReminder(userName: $userName, customerEmail: $customerEmail, role: $role, profile: $profile) {
      message
    }
  }
`

export const sendSessionIDMutation = gql`
  mutation setFitProfileSession(
    $id: Int, $role: String, $uuid: String!, $email: String!, $userId: Int!, $profile: String, 
    $accountManager: String!, $userShortId: String!, $firstName: String, $lastName: String, $isUpdate: Boolean
  ) {
    setFitProfileSession(
      id: $id
      uuid: $uuid
      email: $email
      userId: $userId
      accountManager: $accountManager
      userShortId: $userShortId
      firstName: $firstName
      lastName: $lastName
      profile: $profile
      role: $role
      isUpdate: $isUpdate
    ) {
      message
    }
  }
`

export const sendFitProfileMutation = gql`
  mutation sendFitProfile($id: Int,$input: ManualProfile!, $name: String, $role: String) {
    upsertFitProfile(id: $id, fitProfile: $input, name: $name, role: $role) {
      message
    }
  }
`

export const confirmFitProfileMutation = gql`
  mutation confirmFitProfile($id: Int!) {
    confirmFitProfile(id: $id) {
      message
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/SizeRecModal/data.ts